(function() {
  'use strict';

  // 从URL参数中获取index参数的通用函数
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(name);
    return value !== null ? parseInt(value, 10) : null;
  }

  // Tab切换功能初始化（PC端和移动端都可用）
  function initTabSwitching(section) {
    const items = section.querySelectorAll('.mt-feature-cards__item:not(.mt-feature-cards__item--clone)');
    
    if (items.length === 0) return;
    
    // 检查是否已经初始化过tab功能
    if (section.hasAttribute('data-tab-initialized')) {
      return;
    }
    section.setAttribute('data-tab-initialized', 'true');
    
    // 默认激活第一个tab，但如果URL中有index参数则使用它
    // URL参数是1-based的（1表示第一张，2表示第二张）
    const urlIndex = getUrlParameter('index');
    let activeTabIndex = 0;
    if (urlIndex !== null && !isNaN(urlIndex) && urlIndex >= 1 && urlIndex <= items.length) {
      // URL参数是1-based，转换为0-based的内部索引
      activeTabIndex = urlIndex - 1;
    } 
    
    // 初始化：显示第一个tab对应的内容，隐藏其他内容
    function updateTabContent(tabIndex) {
      // 更新tab激活状态
      items.forEach(function(item, index) {
        if (index === tabIndex) {
          item.classList.add('mt-feature-cards__item--active');
        } else {
          item.classList.remove('mt-feature-cards__item--active');
        }
      });
      
      // 控制基于data_tab属性的内容显示/隐藏
      // 查找所有带有data_tab属性的元素
      const allTabContent = document.querySelectorAll('[data_tab]');
      allTabContent.forEach(function(element) {
        const tabValue = element.getAttribute('data_tab');
        // 将tabValue转换为数字进行比较
        const elementTabIndex = parseInt(tabValue, 10);
        
        // 如果data_tab为0，则在所有tab下都显示
        // data_tab是1-based的（1表示第一个tab，2表示第二个tab...）
        // tabIndex是0-based的（0表示第一个tab，1表示第二个tab...）
        if (!isNaN(elementTabIndex) && (elementTabIndex === 0 || elementTabIndex === tabIndex + 1)) {
          // 显示匹配的内容
          element.style.display = '';
          // 移除可能的隐藏类
          element.classList.remove('mt-tab-content-hidden');
        } else {
          // 隐藏不匹配的内容
          element.style.display = 'none';
          element.classList.add('mt-tab-content-hidden');
        }
      });
    }
    
    // 为每个tab项添加点击事件
    items.forEach(function(item, index) {
      item.addEventListener('click', function(e) {
        // 防止事件冒泡
        e.stopPropagation();
        
        // 更新激活的tab索引
        activeTabIndex = index;
        
        // 更新tab内容和显示状态
        updateTabContent(activeTabIndex);
      });
    });
    
    // 初始化：激活第一个tab
    updateTabContent(activeTabIndex);
  }
  
  function initFeatureCardsCarousel() {
    console.log('initFeatureCardsCarousel 开始执行');
    const sections = document.querySelectorAll('.mt-feature-cards[data-section-id]');
    console.log('找到的sections数量:', sections.length);
    
    sections.forEach(function(section) {
      // 初始化tab切换功能（PC端和移动端都可用）
      initTabSwitching(section);
      
      // 检查是否已经初始化过轮播
      if (section.hasAttribute('data-carousel-initialized')) {
        return;
      }

      const track = section.querySelector('.mt-feature-cards__track');
      if (!track) return;
      
      const wrapper = section.querySelector('.mt-feature-cards__wrapper');
      if (!wrapper) return;

      let items = wrapper.querySelectorAll('.mt-feature-cards__item');
      if (items.length === 0) return;

      // 只在移动端启用轮播
      const isMobile = window.innerWidth <= 750;
      if (!isMobile) {
        return;
      }

      const totalItems = items.length;
      if (totalItems <= 1) return;

      // 确保容器已经渲染，有宽度
      if (track.offsetWidth === 0) {
        // 如果容器还没有宽度，等待一下再初始化
        setTimeout(function() {
          initFeatureCardsCarousel();
        }, 50);
        return;
      }

      // 标记为已初始化，防止重复初始化
      section.setAttribute('data-carousel-initialized', 'true');

      // 获取倒计时秒数（0 或以下表示不自动轮播）
      const autoplayIntervalRaw = parseInt(section.getAttribute('data-autoplay-interval'), 10);
      // 如果没配置或配置为无效值，则默认不自动轮播（0）
      const autoplayInterval = isNaN(autoplayIntervalRaw) ? 0 : autoplayIntervalRaw;
      const autoplayDuration = autoplayInterval > 0 ? autoplayInterval * 1000 : 0; // 转换为毫秒，0 表示关闭自动播放

      // dot点数量 = 卡片数量 - 1（因为一次显示2张）
      const totalDots = totalItems - 1;

      // 创建分页指示器
      let pagination = section.querySelector('.mt-feature-cards__pagination');
      if (!pagination) {
        pagination = document.createElement('div');
        pagination.className = 'mt-feature-cards__pagination';
        section.querySelector('.mt-feature-cards__container').appendChild(pagination);
      } else {
        pagination.innerHTML = '';
      }

      // 创建带倒计时的分页点（数量为 totalItems - 1）
      const dots = [];
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'mt-feature-cards__pagination-dot';
        dot.setAttribute('data-index', i);
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        
        // 创建进度条
        const progress = document.createElement('div');
        progress.className = 'mt-feature-cards__pagination-progress';
        dot.appendChild(progress);
        
        pagination.appendChild(dot);
        dots.push(dot);
      }

      let currentIndex = 0;
      let autoplayTimer = null;
      let progressTimer = null;
      let isPaused = false;
      let isDragging = false;
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let currentY = 0;
      let startTranslateX = 0;
      let translateX = 0;
      let isHorizontalSwipe = false; // 是否确认是横向滑动
      let swipeDirection = null; // 滑动方向：'horizontal' 或 'vertical'

      // 克隆首尾元素实现无限轮播
      // 克隆最后一张放在最前面（用于向左滑动时显示）
      const lastClone = items[totalItems - 1].cloneNode(true);
      lastClone.classList.add('mt-feature-cards__item--clone');
      // 确保克隆元素有正确的样式
      lastClone.style.width = '';
      lastClone.style.display = '';
      wrapper.insertBefore(lastClone, items[0]);
      
      // 克隆第一张放在最后面（用于向右滑动时显示）
      const firstClone = items[0].cloneNode(true);
      firstClone.classList.add('mt-feature-cards__item--clone');
      // 确保克隆元素有正确的样式
      firstClone.style.width = '';
      firstClone.style.display = '';
      wrapper.appendChild(firstClone);

      // 重新获取所有元素（包括克隆的）
      items = wrapper.querySelectorAll('.mt-feature-cards__item');
      
      // 设置初始位置（显示第一张和第二张真实卡片）
      // 因为第一个是克隆的最后一张，所以从索引1开始（显示真实的第一张和第二张）
      // URL参数是1-based的（1表示第一张，2表示第二张）
      const urlIndex = getUrlParameter('index');
      // urlIndex 的有效范围是 1 到 totalItems
      // currentIndex 的最大值是 totalDots（因为一次显示2张，所以最多有 totalDots 个位置）
      if (urlIndex !== null && !isNaN(urlIndex) && urlIndex >= 1 && urlIndex <= totalItems) {
        // URL参数是1-based，转换为currentIndex
        // 因为第一个是克隆的，所以 currentIndex = urlIndex（URL参数1对应currentIndex 1，显示第一张和第二张）
        // 但是要确保 currentIndex 不超过 totalDots
        currentIndex = Math.min(urlIndex, totalDots);
        // 调试信息（可以删除）
        console.log('轮播 - URL index参数:', urlIndex, 'totalItems:', totalItems, 'totalDots:', totalDots, 'currentIndex:', currentIndex);
      } else {
        // 默认显示第一个
        currentIndex = 1;
        // 调试信息（可以删除）
        console.log('轮播 - 使用默认索引，urlIndex:', urlIndex, 'totalItems:', totalItems, 'totalDots:', totalDots);
      }
      updateCarousel(false);

      // 更新轮播位置
      function updateCarousel(animate = true) {
        if (animate) {
          track.style.transition = 'transform 0.5s ease';
        } else {
          track.style.transition = 'none';
        }

        // 计算真实索引（用于显示正确的 dot）
        // currentIndex 从 1 开始（因为第一个是克隆的）
        // 一次显示2张，所以 realIndex = currentIndex - 1
        let realIndex = currentIndex - 1;
        if (realIndex < 0) realIndex = totalDots - 1;
        if (realIndex >= totalDots) realIndex = 0;

        // 一次移动1张
        // 使用实际的item元素宽度来计算，而不是视口宽度
        // 这样可以确保精确对齐
        const gap = 10; // gap 16px
        const viewportWidth = window.innerWidth;
        
        // 获取第一个真实item（非克隆）的实际宽度
        const firstRealItem = wrapper.querySelector('.mt-feature-cards__item:not(.mt-feature-cards__item--clone)');
        let itemWidth = 0;
        if (firstRealItem) {
          itemWidth = firstRealItem.getBoundingClientRect().width;
        } else {
          // 如果获取不到，使用计算值作为后备
          itemWidth = (viewportWidth - gap) / 2;
        }
        
        const moveDistance = itemWidth + gap; // 移动一张的距离（像素）
        translateX = -currentIndex * moveDistance; // 使用像素值
        track.style.transform = `translateX(${translateX}px)`;

        // 更新分页点状态
        dots.forEach(function(dot, index) {
          const progress = dot.querySelector('.mt-feature-cards__pagination-progress');
          if (index === realIndex) {
            dot.classList.add('mt-feature-cards__pagination-dot--active');
            if (progress) {
              progress.style.width = '0%';
              progress.style.transition = 'none'; // 清除过渡，确保可以重新开始动画
            }
          } else {
            dot.classList.remove('mt-feature-cards__pagination-dot--active');
            if (progress) {
              progress.style.width = '0%';
              progress.style.transition = 'none'; // 清除过渡
            }
          }
        });

        // 处理无限循环
        setTimeout(function() {
          const gap = 16;
          const viewportWidth = window.innerWidth;
          if (viewportWidth === 0) return; // 防止视口宽度为0
          
          // 获取第一个真实item的实际宽度
          const firstRealItem = wrapper.querySelector('.mt-feature-cards__item:not(.mt-feature-cards__item--clone)');
          let itemWidth = 0;
          if (firstRealItem) {
            itemWidth = firstRealItem.getBoundingClientRect().width;
          } else {
            itemWidth = (viewportWidth - gap) / 2;
          }
          
          const moveDistance = itemWidth + gap;
          
          if (currentIndex === 0) {
            // 向左滑动到克隆的最后一张，跳转到真实的最后位置
            track.style.transition = 'none';
            currentIndex = totalDots;
            translateX = -currentIndex * moveDistance;
            track.style.transform = `translateX(${translateX}px)`;
          } else if (currentIndex > totalDots) {
            // 向右滑动到克隆的第一张，跳转到真实的第一位置
            track.style.transition = 'none';
            currentIndex = 1;
            translateX = -currentIndex * moveDistance;
            track.style.transform = `translateX(${translateX}px)`;
          }
        }, animate ? 500 : 0);
      }

      // 下一张
      function next() {
        currentIndex++;
        updateCarousel();
        startAutoplay();
      }

      // 上一张
      function prev() {
        currentIndex--;
        updateCarousel();
        startAutoplay();
      }

      // 开始自动播放
      function startAutoplay() {

        stopAutoplay();

        // 如果未配置或配置为 0/负数，则不启用自动轮播
        if (autoplayDuration <= 0) {
          return;
        }
        
        if (isPaused || isDragging) {
          return;
        }

        const realIndex = getRealIndex();
        
        const activeDot = dots[realIndex];
        
        const progress = activeDot ? activeDot.querySelector('.mt-feature-cards__pagination-progress') : null;

        if (progress) {
          progress.style.width = '0%';
          progress.style.transition = 'none';
          // 强制重排
          void progress.offsetWidth;
          progress.style.transition = `width ${autoplayDuration}ms linear`;
          progress.style.width = '100%';
          
          // 检查动画是否真的启动了
          setTimeout(function() {
            const computedWidth = window.getComputedStyle(progress).width;
          }, 100);
        }

        autoplayTimer = setTimeout(function() {
          next();
        }, autoplayDuration);
        
      }

      // 停止自动播放
      function stopAutoplay() {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
        dots.forEach(function(dot) {
          const progress = dot.querySelector('.mt-feature-cards__pagination-progress');
          if (progress) {
            progress.style.width = '0%';
            progress.style.transition = 'none';
          }
        });
      }

      // 获取真实索引
      function getRealIndex() {
        let realIndex = currentIndex - 1;
        if (realIndex < 0) realIndex = totalDots - 1;
        if (realIndex >= totalDots) realIndex = 0;
        return realIndex;
      }

      // 触摸事件处理 - 添加方向识别和滚动冲突处理
      track.addEventListener('touchstart', function(e) {
        isDragging = true;
        isPaused = true;
        stopAutoplay();
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTranslateX = translateX;
        isHorizontalSwipe = false; // 重置方向判断
        swipeDirection = null;
        track.style.transition = 'none';
      }, { passive: true });

      track.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        
        currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
        
        const diffX = currentX - startX;
        const diffY = currentY - startY;
        const absX = Math.abs(diffX);
        const absY = Math.abs(diffY);
        
        // 方向检测：如果还没有确定方向，则根据移动距离判断
        if (!isHorizontalSwipe && swipeDirection === null) {
          // 需要移动至少 10px 才开始判断方向
          if (absX > 10 || absY > 10) {
            if (absX > absY) {
              // 横向滑动
              swipeDirection = 'horizontal';
              isHorizontalSwipe = true;
            } else {
              // 纵向滑动
              swipeDirection = 'vertical';
              isHorizontalSwipe = false;
            }
          }
        }
        
        // 如果是横向滑动，阻止默认滚动行为并更新轮播位置
        if (isHorizontalSwipe && swipeDirection === 'horizontal') {
          e.preventDefault(); // 阻止页面滚动
          translateX = startTranslateX + diffX;
          track.style.transform = `translateX(${translateX}px)`;
        }
        // 如果是纵向滑动，不阻止默认行为，允许页面滚动
      }, { passive: false }); // 改为 false，以便可以使用 preventDefault

      track.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        
        const diffX = currentX - startX;
        const diffY = currentY - startY;
        const absX = Math.abs(diffX);
        const absY = Math.abs(diffY);
        
        // 只有在确认是横向滑动时才处理轮播切换
        if (isHorizontalSwipe && swipeDirection === 'horizontal') {
          isDragging = false;
          track.style.transition = 'transform 0.5s ease';

          const viewportWidth = window.innerWidth;
          const threshold = viewportWidth * 0.15; // 15% 的滑动阈值

          if (absX > threshold) {
            if (diffX > 0) {
              // 向右滑动，显示上一张
              prev();
            } else {
              // 向左滑动，显示下一张
              next();
            }
          } else {
            // 回弹到当前位置
            updateCarousel();
          }

          // 延迟恢复自动播放
          setTimeout(function() {
            isPaused = false;
            startAutoplay();
          }, 500);
        } else {
          // 纵向滑动或未确认方向，直接重置状态
          isDragging = false;
          isPaused = false;
          startAutoplay();
        }
        
        // 重置方向判断
        isHorizontalSwipe = false;
        swipeDirection = null;
      }, { passive: true });

      // 分页点点击事件
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          currentIndex = index + 1; // +1 因为第一个是克隆的
          updateCarousel();
          startAutoplay();
        });
      });

      // 鼠标进入暂停，离开继续
      track.addEventListener('mouseenter', function() {
        isPaused = true;
        stopAutoplay();
      });

      track.addEventListener('mouseleave', function() {
        isPaused = false;
        startAutoplay();
      });

      // 初始化自动播放
      // 使用 requestAnimationFrame 确保 DOM 完全渲染后再启动自动播放
      // 这样可以解决刷新后倒计时点不动的问题
      // 确保初始化时 isPaused 为 false（防止鼠标事件在初始化前触发导致暂停）
      isPaused = false;
      isDragging = false;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          // 再次确保状态正确（防止在 requestAnimationFrame 期间被其他事件改变）
          isPaused = false;
          isDragging = false;
          startAutoplay();
        });
      });

      // 窗口大小改变时重新初始化
      let resizeTimer;
      const handleResize = function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          const isNowMobile = window.innerWidth <= 750;
          if (isNowMobile && isMobile) {
            // 仍然是移动端，重新初始化
            stopAutoplay();
            currentIndex = 1;
            updateCarousel(false);
            startAutoplay();
          } else if (!isNowMobile) {
            // 切换到PC端，停止轮播
            stopAutoplay();
            track.style.transform = '';
            track.style.transition = '';
          }
        }, 250);
      };

      window.addEventListener('resize', handleResize);

      // 页面可见性变化时暂停/继续
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    });
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeatureCardsCarousel);
  } else {
    initFeatureCardsCarousel();
  }

  // Shopify 主题编辑器支持
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      // 清除初始化标记，允许重新初始化
      if (e.detail && e.detail.sectionId) {
        const section = document.querySelector(`.mt-feature-cards[data-section-id="${e.detail.sectionId}"]`);
        if (section) {
          section.removeAttribute('data-carousel-initialized');
          section.removeAttribute('data-tab-initialized');
        }
      }
      setTimeout(initFeatureCardsCarousel, 100);
    });
    document.addEventListener('shopify:section:reorder', function() {
      // 清除所有初始化标记
      document.querySelectorAll('.mt-feature-cards[data-carousel-initialized]').forEach(function(section) {
        section.removeAttribute('data-carousel-initialized');
      });
      document.querySelectorAll('.mt-feature-cards[data-tab-initialized]').forEach(function(section) {
        section.removeAttribute('data-tab-initialized');
      });
      setTimeout(initFeatureCardsCarousel, 100);
    });
  }
})();

